import { createStyles } from 'antd-style';

export const useStyle = createStyles(({ token, css, cx, responsive }) => ({
  container: css`
    width: ${token.adminSiderWitdh}px;
    height: calc(100vh - ${token.adminHeaderHeight}px);
    overflow: auto;
    position: sticky;
    top: 0;
    transition: width 0.2s;
    inset-inline-start: 0;
    scrollbar-width: thin;
    scrollbar-gutter: stable;
    &.collapsed {
      width: 0;
    }
  `,
  menu: css`
    // 避免菜单项太少时，撑不开侧边栏高度
    min-height: 100%;
  `,
  drawerTitle: css`
    height: ${token.adminHeaderHeight}px;
    display: flex;
    align-items: center;
    padding: ${token.paddingMD}px;
  `,
  drawerBody: css`
    padding: 0;
  `,
}));
